import { Factory } from './factory';
import { PageFavorite } from '../page-favorite';

export class PageFavoriteFactory implements Factory<PageFavorite> {

    buildFromFactory(): PageFavorite {
        return undefined;
    }

    buildFromObject(jsonObject: any): PageFavorite {
        const pageFavorite = new PageFavorite();
        pageFavorite.id = jsonObject.id;
        pageFavorite.pageId = jsonObject.pageId;
        pageFavorite.assignmentSlug = jsonObject.assignmentSlug;

        return pageFavorite;
    }

}
